var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// d:/Vagrant/apache_vm/edu/wp-content/themes/portaledu-escolas/node_modules/core-js/modules/_user-agent.js
// module id = 60
// module chunks = 0